<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-activities">
  <div class="org-admin-activities--layout">
    <app-org-admin-sidebar class="org-admin-activities--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-activities--content">
      <app-page-header></app-page-header>
      <app-activities [showTabs]="true" [useAdminAuditingApi]="true"></app-activities>
    </div>
  </div>
</div>

